import Vue from 'vue'
import Vuex from 'vuex'
import { 
  canvasModule, 
  appModule, 
  sessionModule, 
  projectModule, 
  clientModule, 
  assetModule, 
  sectionModule, 
  equipmentModule,
  uiModule,
  gmapModule,
  divaltoCodesModule,
  divaltoAgenciesModule,
  projectAnalysisModule,
  memberModule,
  divaltoAgenciesMembersModule,
  equipmentDivaltoCodesModule,
  noteModule,
  groupingRulesModule } from './modules';
import plugins from './store.persist';
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    "canvas" : canvasModule,
    "app" : appModule,
    "session" : sessionModule,
    "projects" : projectModule,
    "clients" : clientModule,
    "assets" : assetModule,
    "sections" : sectionModule,
    "equipments" : equipmentModule,
    "ui" : uiModule,
    "gmap": gmapModule,
    'divaltoCodes': divaltoCodesModule,
    'divaltoAgencies': divaltoAgenciesModule,
    'projectAnalysis': projectAnalysisModule,
    'members': memberModule,
    'divaltoAgenciesMembers': divaltoAgenciesMembersModule,
    'equipmentDivaltoCodes': equipmentDivaltoCodesModule,
    'notes': noteModule,
    'groupingRules': groupingRulesModule
  },
  plugins
})
